module.exports = __webpack_public_path__ + "img/CBD-Salve.0b5e5393.png";